import { Table, type TableProps } from 'antd';
import type { ColumnsType } from 'antd/lib/table';
import dayjs from 'dayjs';
import { generatePath, useNavigate, useParams } from 'react-router-dom';

import { DATE_FORMAT_JP, TIME_ZONE } from '@/constants/datetime.constants';
import { ROUTES_PATH } from '@/constants/routes.constants';
import { MATERIAL_PAGINATION_OPTIONS } from '@/constants/table.constants';
import type { MaterialsResponseItem } from '@/features/organization/types';

export function PrinterAndFixturesTable(
  props: TableProps<MaterialsResponseItem>,
) {
  const { id } = useParams();
  const navigate = useNavigate();

  const columns: ColumnsType<MaterialsResponseItem> = [
    {
      title: '店舗名',
      dataIndex: 'shop_name',
      className: 'white-space-pre',
      width: '50%',
      ellipsis: true,
    },
    {
      title: '申請日',
      dataIndex: 'created_at',
      width: '50%',
      ellipsis: true,
      render: createdAt =>
        dayjs(createdAt).tz(TIME_ZONE).format(DATE_FORMAT_JP),
    },
  ];

  function handleOnRow({ id: fixtureId }: MaterialsResponseItem) {
    return {
      ...props.onRow,
      onClick: () =>
        navigate(
          generatePath(ROUTES_PATH.organizationPrinterAndFixturesDetail, {
            id: id!,
            fixtureId: String(fixtureId),
          }),
        ),
    };
  }

  return (
    <Table
      bordered
      rowKey="id"
      columns={columns}
      onRow={handleOnRow}
      rowClassName="cursor-pointer"
      {...props}
      pagination={{ ...MATERIAL_PAGINATION_OPTIONS, ...props.pagination }}
    />
  );
}
